
import { useLocation } from 'react-router-dom';
import { getSessionValue, parseSessionValue, SESSION_KEYS } from '@/service/sessionStore';
import IfRender from '@/components/IfRender';
import Success from './images/success.png';
import Fail from './images/error.png';
import ClassItemUI from '../Course/ClassItem';

import s from './index.module.css';

const Result: React.FC = () => {
  let { state: { type, title, message } } = useLocation();
  const classItem = parseSessionValue(getSessionValue(SESSION_KEYS.SELECTED_CLASS)) as any;
  return (
    <div className={s.result}>
      <img src={type === 'success' ? Success : Fail} draggable={false} alt="" />
      <div>
        <p>{title}</p>
        {message && <p>{message}</p>}
      </div>
      <IfRender show={!!classItem && type === 'success'}>
        <ClassItemUI item={classItem} currId={classItem?.courseId} />
      </IfRender>
    </div>
  )
}

export default Result;
